import { AccessLevel } from './AccessLevel';
import { UserId } from './User';
import type { BoxStatsOverview } from './BoxStats';

export type BoxId = string;

// Visual customisation of a box (emoji + background colour), edited via the
// Appearance modal. `color`/`emoji` are null when unset.
export type BoxDisplay = {
  tile: {
    type: string;
    color?: string | null;
    emoji?: string | null;
  };
};

// Per-box collaboration switches. The server derives defaults from the
// access level (shared boxes turn comments and reactions on) unless the
// owner has set a switch by hand.
export type BoxSettings = {
  commentsEnabled: boolean;
  reactionsEnabled: boolean;
  threadsEnabled: boolean;
};

export interface Box {
  id: BoxId;
  accessLevel: AccessLevel;
  // TODO: https://mindfeed.atlassian.net/browse/SP-505
  // Remove the `isDefault` field
  isDefault: boolean;
  name: string;
  permissions: Permissions;
  // Present on the space's box list `?expand=members`
  members?: Member[];
  display?: BoxDisplay;
  // Present on the space's box list `?expand=stats-overview`
  stats?: BoxStatsOverview;
  // Comments and reactions switches, always sent by the server.
  settings: BoxSettings;
  createdAt: string;
  updatedAt: string;
}

export enum MemberRole {
  Owner = 'owner',
  Viewer = 'viewer',
  Editor = 'editor',
}

export type Capabilities = {
  canView: boolean;
  canEdit: boolean;
  canInviteMembers: boolean;
  canManagePermissions: boolean;
  canDelete: boolean;
};

export type Permissions = {
  role: MemberRole;
  capabilities: Capabilities;
};

export type Member = {
  id: UserId;
  displayName: string;
  firstName?: string | null;
  lastName?: string | null;
  // Show it with useMediaUrl(profileImage.id), not the `href`.
  profileImage?: { id: string; href: string };
  role: MemberRole;
  createdAt: string;
  updatedAt: string;
};
